import { render, staticRenderFns } from "./unUsual.vue?vue&type=template&id=ae2798fa&scoped=true&"
import script from "./unUsual.vue?vue&type=script&lang=js&"
export * from "./unUsual.vue?vue&type=script&lang=js&"
import style0 from "./unUsual.vue?vue&type=style&index=0&id=ae2798fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2798fa",
  null
  
)

export default component.exports